export default __webpack_public_path__ + "static/media/lea_logo.a03b31ba.svg";